import React from 'react'
import BorderWrapper from '../../Apps/SlideApp/components/BorderWrapper.jsx';
import { calculateOpacityHex, HexToRGBA } from '../../Apps/SlideApp/Utils/OpacityUtils.js';
import { getRichTextWhiteSpaceStyle, parseRichHtml } from '../../Apps/SlideApp/Utils/ElementUtils.js';
import { buildPageBackgroundImageValue } from '../pageBackgroundImageStyle.js';
import { buildImageElementStyle, getImageFrameBackgroundColor, getImageShapeBorderRadius } from '../../Apps/SlideApp/Utils/imageElementStyle.js';
import { getPageBackgroundSize, getSlideImageBackgroundSize } from '../../Apps/SlideApp/Utils/slideImageFit.js';
import 'react-quill/dist/quill.snow.css';
import '../../Apps/SlideApp/SlideApp.css';
import parse from 'html-react-parser';
import SVG from 'react-inlinesvg';
import TableBlock from '../tableEditor/TableBlock.jsx';
import { resolveTableModel } from '../tableEditor/tableModel.js';
const RenderJsonSlideTemplate = ({TemplateDesign}) => {
      // Page  Style when border is an Image
      const PageBorderImageStyle=(pageitem)=>{
      var heightInInches=(pageitem.PageHeight*0.0104166667).toFixed(1);
        var widthInInches=(pageitem.PageWidth*0.0104166667).toFixed(1)
      
        return {
        width:widthInInches+'in',height:heightInInches+'in',
        overflow:'hidden',
        backgroundColor:pageitem.PageBackgroundColor+calculateOpacityHex(pageitem.PageOpacity),
        // borderImage:`url(${pageitem.PageBorderImage}) 30 round`,
        // borderWidth:`${pageitem.PageBorderWidth}px`,
          }
      
      
      
    }
    // Page  Style when border is not an  Image
    const PageBorderPatterenStyle=(pageitem)=>{
      var heightInInches=(pageitem.PageHeight*0.0104166667).toFixed(1);
        var widthInInches=(pageitem.PageWidth*0.0104166667).toFixed(1)
     
    
        return  {
          width:widthInInches+'in',height:heightInInches+'in',
          overflow:'hidden',
          backgroundColor:pageitem.PageBackgroundColor+calculateOpacityHex(pageitem.PageOpacity),
          border:`${pageitem.PageBorder} ${pageitem.PageBorderWidth}px ${pageitem.PageBorderColor}`,
         }
      
    }
  return (
     <div  className='w-full'>
    {
        TemplateDesign.map((PageItem,PageIndex)=>(
            <div key={PageIndex}  >
            <div 
            style={
              PageItem.IsPageBorderIsImage===true?PageBorderImageStyle(PageItem):PageBorderPatterenStyle(PageItem)
            } 
              className={` relative w-full h-full `}>
              <BorderWrapper
              borderImage={PageItem.PageBorderImage}
              borderWidth={PageItem.PageBorderWidth}
              borderImageOpacity={PageItem.PageBorderImageOpacity}
              Styles={{
                height:(PageItem.PageHeight*0.0104166667).toFixed(1)+"in",
                width:(PageItem.PageWidth*0.0104166667).toFixed(1)+"in",

                }}
            childrenBackgroundColor={PageItem.PageBackgroundColor+calculateOpacityHex(PageItem.PageOpacity)}
                
              >
              <div style={{
                 backgroundImage: buildPageBackgroundImageValue(PageItem),
                 backgroundSize: getPageBackgroundSize(
                   PageItem.PageBackgroundImageRepeatStatus,
                   PageItem.PageImageFitMode,
                 ),
                 backgroundRepeat: PageItem.PageBackgroundImageRepeatStatus===true?'repeat':'no-repeat',
                 backgroundPosition: PageItem.PageBackgroundImageRepeatStatus===true?'left top':'center',
                //  opacity:PageItem.PageOpacity,
                
              }} className=' h-full' >
              
            {PageItem.Elements.map((ElementItem, index) => {
                let elementToRender = null;

                // 🟦 Heading
                if (ElementItem.ElementType === "Heading") {
                    // Heading Style When Border is an Image
                    const HeadingBorderImageStyle={
                    height:ElementItem.Styles[0].ElementHeight+'px',
                    width:ElementItem.Styles[0].ElementWidth+'px',
                    position:'absolute',
                    top:(ElementItem.Styles[0].ElementTop)+'px',
                    left:(ElementItem.Styles[0].ElementLeft)+'px',
                    borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
                    borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
                    backgroundSize:'cover',
                    zIndex:ElementItem.Styles[0].ElementZIndex,
                    transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
                    willChange: 'transform'
                    // transform: ` ${props.Draggable ? 'none' : 'scale(${1})'}`,
                    // transformOrigin: 'top center',
                    }

                    // Heading Style When Border is not an Image
                    const HeadingBorderPatterenStyle={
                    height:ElementItem.Styles[0].ElementHeight+'px',
                    width:ElementItem.Styles[0].ElementWidth+'px',
                    position:'absolute',
                    top:(ElementItem.Styles[0].ElementTop)+'px',
                    left:(ElementItem.Styles[0].ElementLeft)+'px',
                    border:`${ElementItem.Styles[0].ElementBorderPatteren}  ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
                    borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
                    zIndex:ElementItem.Styles[0].ElementZIndex,
                    transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
                    willChange: 'transform',
                    // transform: ` ${props.Draggable ? 'none' : 'scale(${1})'}`,
                    // transformOrigin: 'top center',

                    }


                    function calculateOpacityHex(opacity) {
                    // Multiply the opacity value by 255 and round the result to the nearest whole number
                    var opacityValue = Math.round(opacity * 255);
                    // Convert the rounded value to a 2-digit hexadecimal value
                    var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
                    // Return the 2-digit hexadecimal value
                    return opacityHex;
                    }
                    elementToRender = (
                    <div style={ElementItem.Styles[0].ElementBorderIsImage===true?HeadingBorderImageStyle:HeadingBorderPatterenStyle}>
      
       <div style={{
         backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
         backgroundImage:`${ElementItem.Styles[0].ElementBackgroundImage!==null?(`linear-gradient(rgba(${HexToRGBA(
          ElementItem.Styles[0].ElementBackgroundColor,
          ElementItem.Styles[0].ElementOpacity
        )}),rgba(${HexToRGBA(
          ElementItem.Styles[0].ElementBackgroundColor,
          ElementItem.Styles[0].ElementOpacity
        )})),  url(${ElementItem.Styles[0].ElementBackgroundImage})`):""}`,
         backgroundRepeat: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'repeat':'no-repeat',
         backgroundPosition: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'left top':'center',
         borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
       }}   className="w-full h-full">

        <div style={{
         fontFamily:ElementItem.Styles[0].ElementFontFamily,
         fontSize:ElementItem.Styles[0].ElementFontSize+'px',
         fontStyle:ElementItem.Styles[0].ElementFontStyle,
         fontWeight:ElementItem.Styles[0].ElementFontWeight,
         letterSpacing:ElementItem.Styles[0].ElementLetterSpacing+'px',
         lineHeight:ElementItem.Styles[0].ElementLineHeight,
         color:ElementItem.Styles[0].ElementTextColor,
         textAlign:ElementItem.Styles[0].ElementTextAlignment,
         textDecoration:ElementItem.Styles[0].ElementTextDecoration,
         borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
         ...getRichTextWhiteSpaceStyle(!ElementItem.Speak2ContentType),
         }}   className="w-full h-full p-1 overflow-hidden">
          { parseRichHtml(ElementItem.ElementData, !ElementItem.Speak2ContentType) }
        </div>
      </div>
       
       </div>
                    );
                }

                // 🟩 Paragraph
                else if (ElementItem.ElementType === "Paragraph") {
                     // Paragraph  style when border is an Image
    const ParagraphBorderImageStyle={
      height:ElementItem.Styles[0].ElementHeight+'px',
      width:ElementItem.Styles[0].ElementWidth+'px',
      position:'absolute',
      top:(ElementItem.Styles[0].ElementTop)+'px',
      left:(ElementItem.Styles[0].ElementLeft)+'px',
      borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
      borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
      backgroundSize:'cover',
      zIndex:ElementItem.Styles[0].ElementZIndex,
      transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
      willChange: 'transform',
    }
    // Paragraph  style when border is not an Image
    const ParagraphBorderPatterenStyle={
      height:ElementItem.Styles[0].ElementHeight+'px',
      width:ElementItem.Styles[0].ElementWidth+'px',
      position:'absolute',
      top:(ElementItem.Styles[0].ElementTop)+'px',
      left:(ElementItem.Styles[0].ElementLeft)+'px',
      border:`${ElementItem.Styles[0].ElementBorderPatteren} ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
      borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
      zIndex:ElementItem.Styles[0].ElementZIndex,
      transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
      willChange: 'transform',
    }
  
  function calculateOpacityHex(opacity) {
    // Multiply the opacity value by 255 and round the result to the nearest whole number
    var opacityValue = Math.round(opacity * 255);
    // Convert the rounded value to a 2-digit hexadecimal value
    var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
    // Return the 2-digit hexadecimal value
    return opacityHex;
  }
                    elementToRender = (
                    <div style={ElementItem.Styles[0].ElementBorderIsImage===true?ParagraphBorderImageStyle:ParagraphBorderPatterenStyle}>
       
        <div style={{
          backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
          borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
        }}   className="w-full h-full">
        
         <textarea  type="text" style={{fontFamily:ElementItem.Styles[0].ElementFontFamily,
          fontSize:ElementItem.Styles[0].ElementFontSize+'px',
          fontStyle:ElementItem.Styles[0].ElementFontStyle,
          fontWeight:ElementItem.Styles[0].ElementFontWeight,
          letterSpacing:ElementItem.Styles[0].ElementLetterSpacing+'px',
          lineHeight:ElementItem.Styles[0].ElementLineHeight,
          backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
          backgroundImage:`${ElementItem.Styles[0].ElementBackgroundImage!==null?(`linear-gradient(rgba(${HexToRGBA(
            ElementItem.Styles[0].ElementBackgroundColor,
            ElementItem.Styles[0].ElementOpacity
          )}),rgba(${HexToRGBA(
            ElementItem.Styles[0].ElementBackgroundColor,
            ElementItem.Styles[0].ElementOpacity
          )})),  url(${ElementItem.Styles[0].ElementBackgroundImage})`):""}`,
          backgroundRepeat: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'repeat':'no-repeat',
          backgroundPosition: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'left top':'center',
          borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
          color:ElementItem.Styles[0].ElementTextColor,
          textAlign:ElementItem.Styles[0].ElementTextAlignment,
          textDecoration:ElementItem.Styles[0].ElementTextDecoration,
          backgroundSize:'cover',
          
          }}  placeholder="Paragraph..."   value={ElementItem.ElementData} readOnly={ElementItem.isElementSelected===true?false:true}   className={` w-full h-full  resize-none text-justify   text-gray-900  focus:ring-blue-500 focus:border-blue-500 block p-1   dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}  />
       </div>
        </div>
                    );
                }

                // 🟧 Rich Text
                else if (ElementItem.ElementType === "RTE") {
                    // RTE Style when border is an Image
  const RTEBorderImageStyle={
    height:ElementItem.Styles[0].ElementHeight+'px',
    width:ElementItem.Styles[0].ElementWidth+'px',
    position:'absolute',
    top:(ElementItem.Styles[0].ElementTop)+'px',
    left:(ElementItem.Styles[0].ElementLeft)+'px',
    overflow:'hidden',
    borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
    borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
    zIndex:ElementItem.Styles[0].ElementZIndex,
    transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
    willChange: 'transform',
  }
  // RTE Style when border is not  an Image
  const RTEBorderPatterenStyle={
    height:ElementItem.Styles[0].ElementHeight+'px',
    width:ElementItem.Styles[0].ElementWidth+'px',
    position:'absolute',
    top:(ElementItem.Styles[0].ElementTop)+'px',
    left:(ElementItem.Styles[0].ElementLeft)+'px',
    overflow:'hidden',
    border:`${ElementItem.Styles[0].ElementBorderPatteren} ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
    borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
    zIndex:ElementItem.Styles[0].ElementZIndex,
    transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
    willChange: 'transform',
  }

  



  function calculateOpacityHex(opacity) {
    // Multiply the opacity value by 255 and round the result to the nearest whole number
    var opacityValue = Math.round(opacity * 255);
    // Convert the rounded value to a 2-digit hexadecimal value
    var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
    // Return the 2-digit hexadecimal value
    return opacityHex;
  }
                    elementToRender = (
                   <div style={ElementItem.Styles[0].ElementBorderIsImage===true?RTEBorderImageStyle:RTEBorderPatterenStyle}>
                         
                          <div style={{
                            backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
                            borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
                            backgroundImage:`${ElementItem.Styles[0].ElementBackgroundImage!==null?(`linear-gradient(rgba(${HexToRGBA(
                             ElementItem.Styles[0].ElementBackgroundColor,
                             ElementItem.Styles[0].ElementOpacity
                           )}),rgba(${HexToRGBA(
                             ElementItem.Styles[0].ElementBackgroundColor,
                             ElementItem.Styles[0].ElementOpacity
                           )})),  url(${ElementItem.Styles[0].ElementBackgroundImage})`):""}`,
                            backgroundRepeat: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'repeat':'no-repeat',
                            backgroundPosition: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'left top':'center',
                           //  backgroundColor:ElementItem.Styles[0].ElementBackgroundColor,
                          }}   className="w-full h-full">
                          
                          <div className="ql-editor" style={{  borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',}}>
                           {
                             parse(`${ElementItem.ElementData}`)
                           }
                           
                         </div>
                          </div>
                          </div>
                    );
                }

                // 🟨 Line
                else if (ElementItem.ElementType === "Line") {
                    // Line  style When Border is an Image
                          const LineBorderImageStyle={
                            height:ElementItem.Styles[0].ElementHeight+'px',
                            width:ElementItem.Styles[0].ElementWidth+'px',
                            position:'absolute',
                            top:(ElementItem.Styles[0].ElementTop)+'px',
                            left:(ElementItem.Styles[0].ElementLeft)+'px',
                            borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
                            borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
                            backgroundColor:ElementItem.Styles[0].ElementBackgroundColor,
                            backgroundSize:'cover',
                            opacity: ElementItem.Styles[0].ElementOpacity,
                            zIndex:ElementItem.Styles[0].ElementZIndex,
                            transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
                            willChange: 'transform',
                          }
                    
                          // Line  style When Border is not an  Image
                          const LineBorderPatterenStyle={
                            height:ElementItem.Styles[0].ElementHeight+'px',
                            width:ElementItem.Styles[0].ElementWidth+'px',
                            position:'absolute',
                            top:(ElementItem.Styles[0].ElementTop)+'px',
                            left:(ElementItem.Styles[0].ElementLeft)+'px',
                            border:`${ElementItem.Styles[0].ElementBorderPatteren} ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
                            borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
                            backgroundColor:ElementItem.Styles[0].ElementBackgroundColor,
                            opacity: ElementItem.Styles[0].ElementOpacity,
                            zIndex:ElementItem.Styles[0].ElementZIndex,
                            transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
                            willChange: 'transform',
                          }
                          
                          
                    
                      
                          
                      function calculateOpacityHex(opacity) {
                        // Multiply the opacity value by 255 and round the result to the nearest whole number
                        var opacityValue = Math.round(opacity * 255);
                        // Convert the rounded value to a 2-digit hexadecimal value
                        var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
                        // Return the 2-digit hexadecimal value
                        return opacityHex;
                      }
                    elementToRender = (
                    <div style={ElementItem.Styles[0].ElementBorderIsImage===true?LineBorderImageStyle:LineBorderPatterenStyle}>
            
             <div style={{
              //  opacity: ElementItem.Styles[0].ElementOpacity,
               backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
               borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
               backgroundImage:`${ElementItem.Styles[0].ElementBackgroundImage!==null?(`linear-gradient(rgba(${HexToRGBA(
                ElementItem.Styles[0].ElementBackgroundColor,
                ElementItem.Styles[0].ElementOpacity
              )}),rgba(${HexToRGBA(
                ElementItem.Styles[0].ElementBackgroundColor,
                ElementItem.Styles[0].ElementOpacity
              )})),  url(${ElementItem.Styles[0].ElementBackgroundImage})`):""}`,
               backgroundRepeat: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'repeat':'no-repeat',
               backgroundPosition: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'left top':'center',
               backgroundSize:'cover',
             }}   className={`w-full h-full `}>
             
            </div>
             
             </div>
                    );
                }

                // 🟪 Image
                else if (ElementItem.ElementType === "Image") {
                     // Image  Style When Border is An Image
     const ImageBorderImageStyle={
      height:ElementItem.Styles[0].ElementHeight+'px',
      width:ElementItem.Styles[0].ElementWidth+'px',
      position:'absolute',
      top:(ElementItem.Styles[0].ElementTop)+'px',
      left:(ElementItem.Styles[0].ElementLeft)+'px',
      borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
      borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
      backgroundColor:ElementItem.Styles[0].ElementBackgroundColor,
      backgroundSize:'cover',
      backgroundColor:getImageFrameBackgroundColor(ElementItem.Styles[0], PageItem),
      zIndex:ElementItem.Styles[0].ElementZIndex,
      transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
      willChange: 'transform',
       
    }
    // Image  Style When Border is not an  Image
    const ImageBorderPatterenStyle={
      height:ElementItem.Styles[0].ElementHeight+'px',
      width:ElementItem.Styles[0].ElementWidth+'px',
      position:'absolute',
      top:(ElementItem.Styles[0].ElementTop)+'px',
      left:(ElementItem.Styles[0].ElementLeft)+'px',
      border:`${ElementItem.Styles[0].ElementBorderPatteren} ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
      borderRadius:getImageShapeBorderRadius(ElementItem.Styles[0]),
      backgroundColor:ElementItem.Styles[0].ElementBackgroundColor,
      backgroundColor: getImageFrameBackgroundColor(ElementItem.Styles[0], PageItem),
      zIndex:ElementItem.Styles[0].ElementZIndex,
      transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
      willChange: 'transform',
      
    }
                    elementToRender = (
                    <div style={ElementItem.Styles[0].ElementBorderIsImage===true?ImageBorderImageStyle:ImageBorderPatterenStyle}>
            
             <div   className="w-full h-full flex">
             
             <div  draggable={false}  className="flex-1" 
              style={{
                ...buildImageElementStyle(ElementItem.Styles[0], PageItem),
                backgroundColor:(ElementItem.Styles[0].IsDragAble===true||ElementItem.Styles[0].IsResizeable===true)?"#4B5563":""
              }} 
              ></div> 
              
            </div>
             
             </div>
                    );
                }

                // 🟥 Video
                else if (ElementItem.ElementType === "Video") {
                    // Video  Style When Border is An Video
     const ImageBorderImageStyle={
      height:ElementItem.Styles[0].ElementHeight+'px',
      width:ElementItem.Styles[0].ElementWidth+'px',
      position:'absolute',
      top:(ElementItem.Styles[0].ElementTop)+'px',
      left:(ElementItem.Styles[0].ElementLeft)+'px',
      borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
      borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
      backgroundColor:ElementItem.Styles[0].ElementBackgroundColor,
      backgroundSize:'cover',
      backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
      zIndex:ElementItem.Styles[0].ElementZIndex,
      transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
      willChange: 'transform',
       
    }
    // Video  Style When Border is not an  Video
    const ImageBorderPatterenStyle={
      height:ElementItem.Styles[0].ElementHeight+'px',
      width:ElementItem.Styles[0].ElementWidth+'px',
      position:'absolute',
      top:(ElementItem.Styles[0].ElementTop)+'px',
      left:(ElementItem.Styles[0].ElementLeft)+'px',
      border:`${ElementItem.Styles[0].ElementBorderPatteren} ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
      borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
      backgroundColor:ElementItem.Styles[0].ElementBackgroundColor,
      backgroundColor: ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
      zIndex:ElementItem.Styles[0].ElementZIndex,
      transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
      willChange: 'transform',
      
    }
      
    

  
  function calculateOpacityHex(opacity) {
    // Multiply the opacity value by 255 and round the result to the nearest whole number
    var opacityValue = Math.round(opacity * 255);
    // Convert the rounded value to a 2-digit hexadecimal value
    var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
    // Return the 2-digit hexadecimal value
    return opacityHex;
  }
                    elementToRender = (
                    <div style={ElementItem.Styles[0].ElementBorderIsImage===true?ImageBorderImageStyle:ImageBorderPatterenStyle}>
            
             <div   className="w-full h-full flex items-center justify-center">
             
             <div  draggable={false}  className="flex-1 items-center justify-center" 
              style={{
                // opacity: ElementItem.Styles[0].ElementOpacity,
                display: "flex",
                backgroundImage:`${ElementItem.Styles[0].ElementBackgroundImage!==null?(`linear-gradient(rgba(${HexToRGBA(
                  ElementItem.Styles[0].ElementBackgroundColor,
                  ElementItem.Styles[0].ElementOpacity
                )}),rgba(${HexToRGBA(
                  ElementItem.Styles[0].ElementBackgroundColor,
                  ElementItem.Styles[0].ElementOpacity
                )})),  url(${ElementItem.Styles[0].ElementBackgroundImage})`):""}`,
                backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
                backgroundRepeat: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'repeat':'no-repeat',
                backgroundPosition: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'left top':'center',
                backgroundSize: getSlideImageBackgroundSize(
                  ElementItem.Styles[0].ElementBackgroundImageRepeatStatus,
                  ElementItem.Styles[0].ElementImageFitMode,
                ),
                borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
              }} 
              >
                Video ({ElementItem.Styles[0].ElementWidth}x{ElementItem.Styles[0].ElementHeight})
              </div> 
              
            </div>
             
             </div>
                    );
                }

                // 🟫 Square
                else if (ElementItem.ElementType === "Square") {
                    // Heading Style When Border is an Image
const SquareBorderImageStyle={
  height:ElementItem.Styles[0].ElementHeight+'px',
  width:ElementItem.Styles[0].ElementWidth+'px',
    position:'absolute',
    top:(ElementItem.Styles[0].ElementTop)+'px',
    left:(ElementItem.Styles[0].ElementLeft)+'px',
    borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
    borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
    backgroundSize:'cover',
    zIndex:ElementItem.Styles[0].ElementZIndex,
    transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
    willChange: 'transform',
     
  }
  // Heading Style When Border is not an Image
  const SquareBorderPatterenStyle={
    height:ElementItem.Styles[0].ElementHeight+'px',
    width:ElementItem.Styles[0].ElementWidth+'px',
    position:'absolute',
    top:(ElementItem.Styles[0].ElementTop)+'px',
    left:(ElementItem.Styles[0].ElementLeft)+'px',
    border:`${ElementItem.Styles[0].ElementBorderPatteren} ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
    borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
    zIndex:ElementItem.Styles[0].ElementZIndex,
    transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
    willChange: 'transform',
  }

  

  function calculateOpacityHex(opacity) {
    // Multiply the opacity value by 255 and round the result to the nearest whole number
    var opacityValue = Math.round(opacity * 255);
    // Convert the rounded value to a 2-digit hexadecimal value
    var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
    // Return the 2-digit hexadecimal value
    return opacityHex;
  }
                    elementToRender = (
                    <div style={ElementItem.Styles[0].ElementBorderIsImage===true?SquareBorderImageStyle:SquareBorderPatterenStyle}>
        
         <div style={{
           
           borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
         }}   className="w-full h-full">
         
          <textarea  type="text" style={{fontFamily:ElementItem.Styles[0].ElementFontFamily,
           fontSize:ElementItem.Styles[0].ElementFontSize+'px',
           fontStyle:ElementItem.Styles[0].ElementFontStyle,
           fontWeight:ElementItem.Styles[0].ElementFontWeight,
           letterSpacing:ElementItem.Styles[0].ElementLetterSpacing+'px',
           lineHeight:ElementItem.Styles[0].ElementLineHeight,
           backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
           backgroundImage:`${ElementItem.Styles[0].ElementBackgroundImage!==null?(`linear-gradient(rgba(${HexToRGBA(
            ElementItem.Styles[0].ElementBackgroundColor,
            ElementItem.Styles[0].ElementOpacity
          )}),rgba(${HexToRGBA(
            ElementItem.Styles[0].ElementBackgroundColor,
            ElementItem.Styles[0].ElementOpacity
          )})),  url(${ElementItem.Styles[0].ElementBackgroundImage})`):""}`,
           backgroundRepeat: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'repeat':'no-repeat',
           backgroundPosition: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'left top':'center',
           backgroundSize:'cover',
           borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
           color:ElementItem.Styles[0].ElementTextColor,
           textAlign:ElementItem.Styles[0].ElementTextAlignment,
           textDecoration:ElementItem.Styles[0].ElementTextDecoration,
           
           }}   value={ElementItem.ElementData} readOnly={ElementItem.isElementSelected===true?false:true}   className={` w-full h-full rounded-[${ElementItem.Styles[0].ElementBorderRadius}]  resize-none text-justify   text-gray-900  focus:ring-blue-500 focus:border-blue-500 block p-1   dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}  />
        </div>
         
         </div>
                    );
                }

                // 🟦 Circle
                else if (ElementItem.ElementType === "Circle") {
                    // Circle Style When Border is an Image
const CircleBorderImageStyle={
  height:ElementItem.Styles[0].ElementHeight+'px',
  width:ElementItem.Styles[0].ElementWidth+'px',
    position:'absolute',
    top:(ElementItem.Styles[0].ElementTop)+'px',
  left:(ElementItem.Styles[0].ElementLeft)+'px',
    borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
    borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
    backgroundSize:'cover',
    zIndex:ElementItem.Styles[0].ElementZIndex,
    transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
    willChange: 'transform',
     
  }
  // Circle Style When Border is not an Image
  const CircleBorderPatterenStyle={
    height:ElementItem.Styles[0].ElementHeight+'px',
    width:ElementItem.Styles[0].ElementWidth+'px',
    position:'absolute',
    top:(ElementItem.Styles[0].ElementTop)+'px',
    left:(ElementItem.Styles[0].ElementLeft)+'px',
    border:`${ElementItem.Styles[0].ElementBorderPatteren} ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
    borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',  
    zIndex:ElementItem.Styles[0].ElementZIndex,
    transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
    willChange: 'transform',
  }


  
  function calculateOpacityHex(opacity) {
    // Multiply the opacity value by 255 and round the result to the nearest whole number
    var opacityValue = Math.round(opacity * 255);
    // Convert the rounded value to a 2-digit hexadecimal value
    var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
    // Return the 2-digit hexadecimal value
    return opacityHex;
  }
                    elementToRender = (
                   <div style={ElementItem.Styles[0].ElementBorderIsImage===true?CircleBorderImageStyle:CircleBorderPatterenStyle}>
        
         <div style={{
          //  opacity: ElementItem.Styles[0].ElementOpacity,
           borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
         }}   className="w-full h-full">
         
          <textarea  type="text" style={{fontFamily:ElementItem.Styles[0].ElementFontFamily,
           fontSize:ElementItem.Styles[0].ElementFontSize+'px',
           fontStyle:ElementItem.Styles[0].ElementFontStyle,
           fontWeight:ElementItem.Styles[0].ElementFontWeight,
           letterSpacing:ElementItem.Styles[0].ElementLetterSpacing+'px',
           lineHeight:ElementItem.Styles[0].ElementLineHeight,
           backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
           backgroundImage:`${ElementItem.Styles[0].ElementBackgroundImage!==null?(`linear-gradient(rgba(${HexToRGBA(
            ElementItem.Styles[0].ElementBackgroundColor,
            ElementItem.Styles[0].ElementOpacity
          )}),rgba(${HexToRGBA(
            ElementItem.Styles[0].ElementBackgroundColor,
            ElementItem.Styles[0].ElementOpacity
          )})),  url(${ElementItem.Styles[0].ElementBackgroundImage})`):""}`,
           backgroundRepeat: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'repeat':'no-repeat',
           backgroundPosition: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'left top':'center',
           backgroundSize:'cover',
           borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
           color:ElementItem.Styles[0].ElementTextColor,
           textAlign:ElementItem.Styles[0].ElementTextAlignment,
           textDecoration:ElementItem.Styles[0].ElementTextDecoration,
          //  opacity:'inherit',
           paddingTop:'30%',
           paddingBottom:'30%',
           paddingLeft:'10%',
           paddingRight:'10%'
           }}   value={ElementItem.ElementData} readOnly={ElementItem.isElementSelected===true?false:true}   className={` w-full h-full rounded-[${ElementItem.Styles[0].ElementBorderRadius}]  resize-none text-justify   text-gray-900  focus:ring-blue-500 focus:border-blue-500 block p-1   dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}  />
        </div>
         
         </div>
                    );
                }

                // 🟩 SemiCircle
                else if (ElementItem.ElementType === "SemiCircle") {
                    // Circle Style When Border is an Image
const SemiCircleBorderImageStyle={
  height:ElementItem.Styles[0].ElementHeight+'px',
  width:ElementItem.Styles[0].ElementWidth+'px',
    position:'absolute',
    top:(ElementItem.Styles[0].ElementTop)+'px',
    left:(ElementItem.Styles[0].ElementLeft)+'px',
    borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
    borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
    backgroundSize:'cover',
    zIndex:ElementItem.Styles[0].ElementZIndex,
    transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
    willChange: 'transform',
     
  }
  // Circle Style When Border is not an Image
  const SemiCircleBorderPatterenStyle={
    height:ElementItem.Styles[0].ElementHeight+'px',
  width:ElementItem.Styles[0].ElementWidth+'px',
    position:'absolute',
    top:(ElementItem.Styles[0].ElementTop)+'px',
    left:(ElementItem.Styles[0].ElementLeft)+'px',
    border:`${ElementItem.Styles[0].ElementBorderPatteren} ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
    borderTopLeftRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
    borderBottomLeftRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
    zIndex:ElementItem.Styles[0].ElementZIndex,
    transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
    willChange: 'transform',
  }


  
 

  function calculateOpacityHex(opacity) {
    // Multiply the opacity value by 255 and round the result to the nearest whole number
    var opacityValue = Math.round(opacity * 255);
    // Convert the rounded value to a 2-digit hexadecimal value
    var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
    // Return the 2-digit hexadecimal value
    return opacityHex;
  }
                    elementToRender = (
                    <div style={ElementItem.Styles[0].ElementBorderIsImage===true?SemiCircleBorderImageStyle:SemiCircleBorderPatterenStyle}>
        
         <div style={{
          //  backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
           borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
         }}   className="w-full h-full">
         
          <textarea  type="text" style={{fontFamily:ElementItem.Styles[0].ElementFontFamily,
           fontSize:ElementItem.Styles[0].ElementFontSize+'px',
           fontStyle:ElementItem.Styles[0].ElementFontStyle,
           fontWeight:ElementItem.Styles[0].ElementFontWeight,
           letterSpacing:ElementItem.Styles[0].ElementLetterSpacing+'px',
           lineHeight:ElementItem.Styles[0].ElementLineHeight,
           backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
           backgroundImage:`${ElementItem.Styles[0].ElementBackgroundImage!==null?(`linear-gradient(rgba(${HexToRGBA(
            ElementItem.Styles[0].ElementBackgroundColor,
            ElementItem.Styles[0].ElementOpacity
          )}),rgba(${HexToRGBA(
            ElementItem.Styles[0].ElementBackgroundColor,
            ElementItem.Styles[0].ElementOpacity
          )})),  url(${ElementItem.Styles[0].ElementBackgroundImage})`):""}`,
           backgroundRepeat: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'repeat':'no-repeat',
           backgroundPosition: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'left top':'center',
           backgroundSize:'cover',
           borderTopLeftRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
           borderBottomLeftRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
           color:ElementItem.Styles[0].ElementTextColor,
           textAlign:ElementItem.Styles[0].ElementTextAlignment,
           textDecoration:ElementItem.Styles[0].ElementTextDecoration,
           
           paddingTop:'30%',
           paddingBottom:'20%',
           paddingLeft:'10%',
           paddingRight:'10%'
           }}   value={ElementItem.ElementData} readOnly={ElementItem.isElementSelected===true?false:true}   className={` w-full h-full rounded-[${ElementItem.Styles[0].ElementBorderRadius}]  resize-none text-justify   text-gray-900  focus:ring-blue-500 focus:border-blue-500 block p-1   dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}  />
        </div>
         
         </div>
                    );
                }

                // 🟧 Star
                else if (ElementItem.ElementType === "Star") {
                   // SemiCircle Style When Border is an Image
const StarBorderImageStyle={
  height:ElementItem.Styles[0].ElementHeight+'px',
  width:ElementItem.Styles[0].ElementWidth+'px',
    position:'absolute',
    top:(ElementItem.Styles[0].ElementTop)+'px',
    left:(ElementItem.Styles[0].ElementLeft)+'px',
    borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
    borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
    backgroundSize:'cover',
    zIndex:ElementItem.Styles[0].ElementZIndex,
    transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
    willChange: 'transform',
     
  }

  // Circle Style When Border is not an Image
  const StarBorderPatterenStyle={
    height:ElementItem.Styles[0].ElementHeight+'px',
  width:ElementItem.Styles[0].ElementWidth+'px',
    position:'absolute',
    top:(ElementItem.Styles[0].ElementTop)+'px',
    left:(ElementItem.Styles[0].ElementLeft)+'px',
    border:`${ElementItem.Styles[0].ElementBorderPatteren} ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
    borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
    zIndex:ElementItem.Styles[0].ElementZIndex,
    transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
    willChange: 'transform',
  }




  function calculateOpacityHex(opacity) {
    // Multiply the opacity value by 255 and round the result to the nearest whole number
    var opacityValue = Math.round(opacity * 255);
    // Convert the rounded value to a 2-digit hexadecimal value
    var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
    // Return the 2-digit hexadecimal value
    return opacityHex;
  }
                    elementToRender = (
                     <div style={ElementItem.Styles[0].ElementBorderIsImage===true?StarBorderImageStyle:StarBorderPatterenStyle}>
        
        <svg  
          className="w-full h-full "
         style={{
          // backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
            borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
            }}
           viewBox="0 0 100 100">
            <defs>
  <pattern id="img1" patternUnits="userSpaceOnUse" width="100" height="100">
    <image href={ElementItem.Styles[0].ElementBackgroundImage} x="0" y="0" width="100" height="100" />
  </pattern>
</defs>
<path  d="M50,10 L61,48 L98,48 L68,58 L80,95 L50,76 L20,95 L32,58 L2,48 L39,48 Z"
  fill="url(#img1)" />
      <polygon
        points="50,10 61,48 98,48 68,58 80,95 50,76 20,95 32,58 2,48 39,48"
        stroke={ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity)}
        strokeWidth="2"
        fill={ElementItem.Styles[0].ElementBackgroundImage!==null?`url(${ElementItem.Styles[0].ElementBackgroundImage})`:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity)}
      />
    
    </svg>
         
         </div>
                    );
                }

                // 🟨 Icon
                else if (ElementItem.ElementType === "Icon") {
                   // SemiCircle Style When Border is an Image
                   const IconBorderImageStyle={
                     height:ElementItem.Styles[0].ElementHeight+'px',
                     width:ElementItem.Styles[0].ElementWidth+'px',
                       position:'absolute',
                       top:(ElementItem.Styles[0].ElementTop)+'px',
                       left:(ElementItem.Styles[0].ElementLeft)+'px',
                       borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
                       borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
                       backgroundSize:'cover',
                       zIndex:ElementItem.Styles[0].ElementZIndex,
                       transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
                       willChange: 'transform',
                     }
                   
                     // Circle Style When Border is not an Image
                     const IconBorderPatterenStyle={
                       height:ElementItem.Styles[0].ElementHeight+'px',
                       width:ElementItem.Styles[0].ElementWidth+'px',
                       position:'absolute',
                       top:(ElementItem.Styles[0].ElementTop)+'px',
                       left:(ElementItem.Styles[0].ElementLeft)+'px',
                       border:`${ElementItem.Styles[0].ElementBorderPatteren} ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
                       borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
                       zIndex:ElementItem.Styles[0].ElementZIndex,
                       transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
                       willChange: 'transform',
                     }
                   
                     
                       
                       
                      
                       
                     
                   
                   
                   
                     function calculateOpacityHex(opacity) {
                       // Multiply the opacity value by 255 and round the result to the nearest whole number
                       var opacityValue = Math.round(opacity * 255);
                       // Convert the rounded value to a 2-digit hexadecimal value
                       var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
                       // Return the 2-digit hexadecimal value
                       return opacityHex;
                     }
                     let IconString = ElementItem.Styles[0].ElementIcon.replace(/fill="#[a-zA-Z0-9]+"/g, `fill="${ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity)}"`);
                    elementToRender = (
                      <div style={ElementItem.Styles[0].ElementBorderIsImage===true?IconBorderImageStyle:IconBorderPatterenStyle}>
        
        <SVG
            src={IconString}
            className="w-full h-full"
            stroke={ElementItem.Styles[0].ElementBackgroundColor}
            fill={ElementItem.Styles[0].ElementBackgroundColor+'!important'}
            style={{
              opacity: ElementItem.Styles[0].ElementOpacity,
              borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
              }}
            />
         
         </div>
                    );
                }

                // 🟪 Content
                else if (ElementItem.ElementType === "Content") {
                     // Paragraph  style when border is an Image
        const ContentBorderImageStyle={
          height:ElementItem.Styles[0].ElementHeight+'px',
          width:ElementItem.Styles[0].ElementWidth+'px',
          position:'absolute',
          top:(ElementItem.Styles[0].ElementTop)+'px',
          left:(ElementItem.Styles[0].ElementLeft)+'px',
          borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
          borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
          backgroundSize:'cover',
          zIndex:ElementItem.Styles[0].ElementZIndex,
          transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
          willChange: 'transform',
        }
        // Paragraph  style when border is not an Image
        const ContentBorderPatterenStyle={
          height:ElementItem.Styles[0].ElementHeight+'px',
          width:ElementItem.Styles[0].ElementWidth+'px',
          position:'absolute',
          top:(ElementItem.Styles[0].ElementTop)+'px',
          left:(ElementItem.Styles[0].ElementLeft)+'px',
          border:`${ElementItem.Styles[0].ElementBorderPatteren} ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
          borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
          zIndex:ElementItem.Styles[0].ElementZIndex,
          transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
          willChange: 'transform',
        }

         function calculateOpacityHex(opacity) {
        // Multiply the opacity value by 255 and round the result to the nearest whole number
        var opacityValue = Math.round(opacity * 255);
        // Convert the rounded value to a 2-digit hexadecimal value
        var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
        // Return the 2-digit hexadecimal value
        return opacityHex;
      }
                    elementToRender = (
                      <div style={ElementItem.Styles[0].ElementBorderIsImage===true?ContentBorderImageStyle:ContentBorderPatterenStyle}>
           
            <div style={{
              backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
              borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
            }}   className="w-full h-full">
            
             <textarea  type="text" style={{fontFamily:ElementItem.Styles[0].ElementFontFamily,
              fontSize:ElementItem.Styles[0].ElementFontSize+'px',
              fontStyle:ElementItem.Styles[0].ElementFontStyle,
              fontWeight:ElementItem.Styles[0].ElementFontWeight,
              letterSpacing:ElementItem.Styles[0].ElementLetterSpacing+'px',
              lineHeight:ElementItem.Styles[0].ElementLineHeight,
              backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
              backgroundImage:`${ElementItem.Styles[0].ElementBackgroundImage!==null?(`linear-gradient(rgba(${HexToRGBA(
                ElementItem.Styles[0].ElementBackgroundColor,
                ElementItem.Styles[0].ElementOpacity
              )}),rgba(${HexToRGBA(
                ElementItem.Styles[0].ElementBackgroundColor,
                ElementItem.Styles[0].ElementOpacity
              )})),  url(${ElementItem.Styles[0].ElementBackgroundImage})`):""}`,
              backgroundRepeat: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'repeat':'no-repeat',
              backgroundPosition: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'left top':'center',
              borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
              color:ElementItem.Styles[0].ElementTextColor,
              textAlign:ElementItem.Styles[0].ElementTextAlignment,
              textDecoration:ElementItem.Styles[0].ElementTextDecoration,
              backgroundSize:'cover',
              
              }}  placeholder="content..."   value={ElementItem.ElementData} readOnly={ElementItem.isElementSelected===true?false:true}   className={` w-full h-full  resize-none text-justify   text-gray-900  focus:ring-blue-500 focus:border-blue-500 block p-1   dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}  />
           </div>
            </div>
                    );
                }

                // 🟥 Date
                else if (ElementItem.ElementType === "Date") {
                    // Heading Style When Border is an Image
  const DateBorderImageStyle={
    height:ElementItem.Styles[0].ElementHeight+'px',
    width:ElementItem.Styles[0].ElementWidth+'px',
    position:'absolute',
    top:(ElementItem.Styles[0].ElementTop)+'px',
    left:(ElementItem.Styles[0].ElementLeft)+'px',
    borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
    borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
    backgroundSize:'cover',
    zIndex:ElementItem.Styles[0].ElementZIndex,
    transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
    willChange: 'transform'
    // transform: ` ${props.Draggable ? 'none' : 'scale(${1})'}`,
    // transformOrigin: 'top center',
  }
  
  // Heading Style When Border is not an Image
  const DateBorderPatterenStyle={
    height:ElementItem.Styles[0].ElementHeight+'px',
    width:ElementItem.Styles[0].ElementWidth+'px',
    position:'absolute',
    top:(ElementItem.Styles[0].ElementTop)+'px',
    left:(ElementItem.Styles[0].ElementLeft)+'px',
    border:`${ElementItem.Styles[0].ElementBorderPatteren}  ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
    borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
    zIndex:ElementItem.Styles[0].ElementZIndex,
    transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
    willChange: 'transform',
    // transform: ` ${props.Draggable ? 'none' : 'scale(${1})'}`,
    // transformOrigin: 'top center',
  
  }
  
  
 
  
  
  function calculateOpacityHex(opacity) {
    // Multiply the opacity value by 255 and round the result to the nearest whole number
    var opacityValue = Math.round(opacity * 255);
    // Convert the rounded value to a 2-digit hexadecimal value
    var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
    // Return the 2-digit hexadecimal value
    return opacityHex;
  }
                    elementToRender = (
                    <div style={ElementItem.Styles[0].ElementBorderIsImage===true?DateBorderImageStyle:DateBorderPatterenStyle}>
        
         <div style={{
          //  opacity: ElementItem.Styles[0].ElementOpacity,
           borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
         }}   className="w-full h-full">
         
          <textarea  type="text" style={{fontFamily:ElementItem.Styles[0].ElementFontFamily,
           fontSize:ElementItem.Styles[0].ElementFontSize+'px',
           fontStyle:ElementItem.Styles[0].ElementFontStyle,
           fontWeight:ElementItem.Styles[0].ElementFontWeight,
           letterSpacing:ElementItem.Styles[0].ElementLetterSpacing+'px',
           lineHeight:ElementItem.Styles[0].ElementLineHeight,
           backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
           backgroundImage:`${ElementItem.Styles[0].ElementBackgroundImage!==null?(`linear-gradient(rgba(${HexToRGBA(
            ElementItem.Styles[0].ElementBackgroundColor,
            ElementItem.Styles[0].ElementOpacity
          )}),rgba(${HexToRGBA(
            ElementItem.Styles[0].ElementBackgroundColor,
            ElementItem.Styles[0].ElementOpacity
          )})),  url(${ElementItem.Styles[0].ElementBackgroundImage})`):""}`,
           backgroundRepeat: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'repeat':'no-repeat',
           backgroundPosition: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'left top':'center',
           backgroundSize:'cover',
           borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
           color:ElementItem.Styles[0].ElementTextColor,
           textAlign:ElementItem.Styles[0].ElementTextAlignment,
           textDecoration:ElementItem.Styles[0].ElementTextDecoration,
          //  opacity:'inherit'
           }}     placeholder="Heading..."  value={ElementItem.ElementData} readOnly={ElementItem.isElementSelected===true?false:true}   className={` w-full h-full rounded-[${ElementItem.Styles[0].ElementBorderRadius}]  resize-none text-justify   text-gray-900  focus:ring-blue-500 focus:border-blue-500 block p-1   dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}  />
        </div>
        
         </div>
                    );
                }

                // 🟫 Table
                else if (ElementItem.ElementType === "Table") {
                    // Paragraph  style when border is an Image
        const TableBorderImageStyle={
          height:ElementItem.Styles[0].ElementHeight+'px',
          width:ElementItem.Styles[0].ElementWidth+'px',
          position:'absolute',
          top:(ElementItem.Styles[0].ElementTop)+'px',
          left:(ElementItem.Styles[0].ElementLeft)+'px',
          borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
          borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
          backgroundSize:'cover',
          zIndex:ElementItem.Styles[0].ElementZIndex,
          transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
          willChange: 'transform',
        }
        // Paragraph  style when border is not an Image
        const TableBorderPatterenStyle={
          height:ElementItem.Styles[0].ElementHeight+'px',
          width:ElementItem.Styles[0].ElementWidth+'px',
          position:'absolute',
          top:(ElementItem.Styles[0].ElementTop)+'px',
          left:(ElementItem.Styles[0].ElementLeft)+'px',
          border:`${ElementItem.Styles[0].ElementBorderPatteren} ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
          borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
          zIndex:ElementItem.Styles[0].ElementZIndex,
          transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
          willChange: 'transform',
        }
          function calculateOpacityHex(opacity) {
        // Multiply the opacity value by 255 and round the result to the nearest whole number
        var opacityValue = Math.round(opacity * 255);
        // Convert the rounded value to a 2-digit hexadecimal value
        var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
        // Return the 2-digit hexadecimal value
        return opacityHex;
      }
                    elementToRender = (
                       <div style={ElementItem.Styles[0].ElementBorderIsImage===true?TableBorderImageStyle:TableBorderPatterenStyle}>
           
            <div style={{
             backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
             backgroundImage:`${ElementItem.Styles[0].ElementBackgroundImage!==null?(`linear-gradient(rgba(${HexToRGBA(
              ElementItem.Styles[0].ElementBackgroundColor,
              ElementItem.Styles[0].ElementOpacity
            )}),rgba(${HexToRGBA(
              ElementItem.Styles[0].ElementBackgroundColor,
              ElementItem.Styles[0].ElementOpacity
            )})),  url(${ElementItem.Styles[0].ElementBackgroundImage})`):""}`,
             backgroundRepeat: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'repeat':'no-repeat',
             backgroundPosition: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'left top':'center',
             backgroundSize:'cover',
             borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
             }}   className="w-full h-full">
            
            <TableBlock
              model={resolveTableModel(ElementItem)}
              readOnly
              selected={false}
            />
           </div>
            </div>
                    );
                }

                // 🟦 Bullets
                else if (ElementItem.ElementType === "Bullets") {
                    // Paragraph  style when border is an Image
        const BulletBorderImageStyle={
          height:ElementItem.Styles[0].ElementHeight+'px',
          width:ElementItem.Styles[0].ElementWidth+'px',
          position:'absolute',
          top:(ElementItem.Styles[0].ElementTop)+'px',
          left:(ElementItem.Styles[0].ElementLeft)+'px',
          borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
          borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
          backgroundSize:'cover',
          zIndex:ElementItem.Styles[0].ElementZIndex,
          transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
          willChange: 'transform',
        }
        // Paragraph  style when border is not an Image
        const BulletBorderPatterenStyle={
          height:ElementItem.Styles[0].ElementHeight+'px',
          width:ElementItem.Styles[0].ElementWidth+'px',
          position:'absolute',
          top:(ElementItem.Styles[0].ElementTop)+'px',
          left:(ElementItem.Styles[0].ElementLeft)+'px',
          border:`${ElementItem.Styles[0].ElementBorderPatteren} ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
          borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
          zIndex:ElementItem.Styles[0].ElementZIndex,
          transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
          willChange: 'transform',
        }
    
    
    

    
      
      function calculateOpacityHex(opacity) {
        // Multiply the opacity value by 255 and round the result to the nearest whole number
        var opacityValue = Math.round(opacity * 255);
        // Convert the rounded value to a 2-digit hexadecimal value
        var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
        // Return the 2-digit hexadecimal value
        return opacityHex;
      }
                    elementToRender = (
                       <div style={ElementItem.Styles[0].ElementBorderIsImage===true?BulletBorderImageStyle:BulletBorderPatterenStyle}>
           
           <div style={{
            backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
            backgroundImage:`${ElementItem.Styles[0].ElementBackgroundImage!==null?(`linear-gradient(rgba(${HexToRGBA(
             ElementItem.Styles[0].ElementBackgroundColor,
             ElementItem.Styles[0].ElementOpacity
           )}),rgba(${HexToRGBA(
             ElementItem.Styles[0].ElementBackgroundColor,
             ElementItem.Styles[0].ElementOpacity
           )})),  url(${ElementItem.Styles[0].ElementBackgroundImage})`):""}`,
            backgroundRepeat: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'repeat':'no-repeat',
            backgroundPosition: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'left top':'center',
            backgroundSize:'cover',
            borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
            
           }} 
            className="w-full h-full">
           
          

        
          </div>  
            </div>
                    );
                }

                // 🟩 Text
                else if (ElementItem.ElementType === "Text") {
                    // Paragraph  style when border is an Image
        const TextBorderImageStyle={
          height:ElementItem.Styles[0].ElementHeight+'px',
          width:ElementItem.Styles[0].ElementWidth+'px',
          position:'absolute',
          top:(ElementItem.Styles[0].ElementTop)+'px',
          left:(ElementItem.Styles[0].ElementLeft)+'px',
          overflow:'hidden',
          borderImage:`url(${ElementItem.Styles[0].ElementBorderImage}) 30 round`,
          borderWidth:`${ElementItem.Styles[0].ElementBorderWidth}px`,
          backgroundSize:'cover',
          zIndex:ElementItem.Styles[0].ElementZIndex,
          transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
          willChange: 'transform',
        }
        // Paragraph  style when border is not an Image
        const TextBorderPatterenStyle={
          height:ElementItem.Styles[0].ElementHeight+'px',
          width:ElementItem.Styles[0].ElementWidth+'px',
          position:'absolute',
          top:(ElementItem.Styles[0].ElementTop)+'px',
          left:(ElementItem.Styles[0].ElementLeft)+'px',
          overflow:'hidden',
          border:`${ElementItem.Styles[0].ElementBorderPatteren} ${ElementItem.Styles[0].ElementBorderWidth}px ${ElementItem.Styles[0].ElementBorderColor}`,
          borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
          zIndex:ElementItem.Styles[0].ElementZIndex,
          transform: `rotate(${ElementItem.Styles[0].ElementRotation}deg)`,
          willChange: 'transform',
        }
      
      function calculateOpacityHex(opacity) {
        // Multiply the opacity value by 255 and round the result to the nearest whole number
        var opacityValue = Math.round(opacity * 255);
        // Convert the rounded value to a 2-digit hexadecimal value
        var opacityHex = opacityValue.toString(16).toUpperCase().padStart(2, '0');
        // Return the 2-digit hexadecimal value
        return opacityHex;
      }
                    elementToRender = (
                     <div style={ElementItem.Styles[0].ElementBorderIsImage===true?TextBorderImageStyle:TextBorderPatterenStyle}>
                              
                               <div style={{
                                 backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
                                 borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
                               }}   className="w-full h-full">
                               
                                 <div style={{fontFamily:ElementItem.Styles[0].ElementFontFamily,
                      fontSize:ElementItem.Styles[0].ElementFontSize+'px',
                      fontStyle:ElementItem.Styles[0].ElementFontStyle,
                     //  fontWeight:ElementItem.Styles[0].ElementFontWeight,
                      letterSpacing:ElementItem.Styles[0].ElementLetterSpacing+'px',
                      lineHeight:ElementItem.Styles[0].ElementLineHeight,
                      backgroundColor:ElementItem.Styles[0].ElementBackgroundColor+calculateOpacityHex(ElementItem.Styles[0].ElementOpacity),
                      backgroundImage:`${ElementItem.Styles[0].ElementBackgroundImage!==null?(`linear-gradient(rgba(${HexToRGBA(
                        ElementItem.Styles[0].ElementBackgroundColor,
                        ElementItem.Styles[0].ElementOpacity
                      )}),rgba(${HexToRGBA(
                        ElementItem.Styles[0].ElementBackgroundColor,
                        ElementItem.Styles[0].ElementOpacity
                      )})),  url(${ElementItem.Styles[0].ElementBackgroundImage})`):""}`,
                      backgroundRepeat: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'repeat':'no-repeat',
                      backgroundPosition: ElementItem.Styles[0].ElementBackgroundImageRepeatStatus===true?'left top':'center',
                      borderRadius:ElementItem.Styles[0].ElementBorderRadius+'px',
                      color:ElementItem.Styles[0].ElementTextColor,
                      textAlign:ElementItem.Styles[0].ElementTextAlignment,
                      textDecoration:ElementItem.Styles[0].ElementTextDecoration,
                      backgroundSize:'cover',
                      ...getRichTextWhiteSpaceStyle(!ElementItem.Speak2ContentType),
                      }}  className="w-full h-full p-1">

                          {
                             parseRichHtml(ElementItem.ElementData, !ElementItem.Speak2ContentType)
                           }
                          </div>
                              </div>
                               </div>
                    );
                }

                return <div key={index}>{elementToRender}</div>;
                })}

            </div>
            </BorderWrapper>
            </div>
            </div>
          
         
        ))
      }
      </div>
  )
}

export default RenderJsonSlideTemplate